import { z } from "zod";
import { isTwoOrMoreElements, map } from "./functional";
function safeParse(schema, data) {
  const result = schema.optional().safeParse(data);
  return result.success ? { success: true, data: result.data } : { success: false, error: summarizeError(result.error) };
}
function summarizeError(error) {
  const { formErrors, fieldErrors } = error.flatten();
  return [
    ...formErrors.slice(0, 1),
    ...Object.entries(fieldErrors).map(
      ([field, error2]) => `${field}: ${error2}`
    )
  ].join("; ");
}
function unionOfLiterals(constants) {
  const c = isTwoOrMoreElements(constants) ? constants : [constants[0], constants[0]];
  return z.union(map(c, (x) => z.literal(x)));
}
export {
  safeParse,
  summarizeError,
  unionOfLiterals
};
//# sourceMappingURL=zod.js.map